import { z } from 'zod';
import { FieldListParamsSchema } from './fieldlist';
import { CommonHttpParamsSchema } from '../common/http-params';
import { InitialUIElement } from '../initial-ui-element';

export const ENTITY_FIELD_GROUP_ELEMENT_TYPE = 'entityfieldgroup' as const;
export const EntityFieldGroupElementType = z.literal(ENTITY_FIELD_GROUP_ELEMENT_TYPE);

export type TEntityFieldGroupElementType = z.infer<typeof EntityFieldGroupElementType>;

export const EntityFieldGroupHttpParamsSchema = z.object({});

// Entity types for array-based entity collections (e.g., multiple directors, UBOs)
export const EntityFieldGroupParamsSchema = FieldListParamsSchema.extend({
  type: z.union([
    z.literal('ubo'),
    z.literal('director'),
    z.literal('trustee'),
    z.literal('member'),
    z.literal('partner'),
  ]),
  createEntityText: z.string().optional(),
  httpParams: z.object({
    createEntity: z.object({
      httpParams: CommonHttpParamsSchema,
      transform: z.string().optional(),
    }),
    updateEntity: z.object({
      httpParams: CommonHttpParamsSchema,
      transform: z.string().optional(),
    }),
    deleteEntity: CommonHttpParamsSchema,
    uploadDocument: CommonHttpParamsSchema.optional(),
    deleteDocument: CommonHttpParamsSchema.optional(),
  }),
});

export type TEntityFieldGroupParams = z.infer<typeof EntityFieldGroupParamsSchema>;

export const EntityFieldGroupElementSchema = InitialUIElement.extend({
  element: EntityFieldGroupElementType,
  params: EntityFieldGroupParamsSchema,
  valueDestination: z.string(),
});
